import type { Theme } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }: { theme: Theme }) => ({
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    minHeight: '3rem',
    padding: '0rem 1rem',
    '& > .MuiCardHeader-content': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  cardContentBox: {
    marginTop: '0!important'
  }
}));

export default useStyles;
